app.service('basketProduct', function (console, orderUtils, basketUtils, message, pageConfig, modal, log, basketAnalytics) {
	function removeSuite(itemId){
		console.log('USUWANIE ZESTAWU');
		basketAnalytics.removeItem(itemId);
		basketUtils.needRefresh(function () {
			basketUtils.skipValidation();
			basketUtils.incBacks();
			$('#F_SELECTED_ITEM').val(itemId);
			orderUtils.send('DELETE_ITEM', true);
		});
	}
	function remove(itemId) {
		console.log('USUWANIE PRODUKTU');
		basketAnalytics.removeItem(itemId);
		basketUtils.needRefresh(function () {
			basketUtils.skipValidation();
			basketUtils.incBacks();
			$('#F_SELECTED_ITEM').val(itemId);
			orderUtils.send('DELETE_ITEM', true);
		});
	}
	function increase(value, productId) {
		change(value, productId);
	}
	function decrease(value, productId) {
		change(value, productId);
	}

	function change(value, productId) {
		function changeForce() {
			if ($productInput.length) {
				basketAnalytics.changeQuantity(productId, value);
				$productInput.val(value).change();
			} else {
				modal.alert('Błąd zmiany ilości. Prosimy spróbować później');
			}
		}
		var $warrantyInput = $('#warranty-' + productId);
		var $productInput = $('#product-' + productId);
		if ($warrantyInput.length && value > $warrantyInput.val() / 1) {
			message.get('cart.bhtmlCheckWarranty').then(function (text) {
				modal.generate({
					id: 'modal-change-quantity',
					content: '<h2>' + text + '</h2>',
					buttons: [
						{
							text: 'Tak',
							click: function () {
								modal.close();
								$warrantyInput.val(value);
								changeForce();
							},
							cssClass: 'btn-second'
						},
						{
							text: 'Nie',
							click: function () {
								modal.close();
								changeForce();
							},
							cssClass: 'btn-third'
						}
					]
				})
			});
		} else {
			changeForce();
		}
	}

	return {
		remove,
		removeSuite,
		change,
		increase,
		decrease
	};
});
